export const DEFAULT_GAME_COLORS = [
  '#DFE6E9',
  '#E9D8A6',
  '#FAB1A0',
  '#8E9B97',
  '#55EFC4',
  '#7BED9F',
  '#74B9FF',
  '#F9C74F',
  '#EDAE49',
  '#FBC531',
  '#FF9F43',
  '#2ECC71',
  '#1ABC9C',
  '#A29BFE',
  '#FF7675',
  '#EE9B00',
  '#43AA8B',
  '#3498DB',
  '#FF6B81',
  '#537072',
  '#00798C',
  '#6C5CE7',
  '#8E44AD',
  '#005F73',
  '#AE2012',
  '#2C3E50',
  '#33351D',
  '#001219',
]

export const getRandomGameColor = (): string => {
  const randomIndex = Math.floor(Math.random() * DEFAULT_GAME_COLORS.length)
  return DEFAULT_GAME_COLORS[randomIndex]
}
